import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import servicesApi from "../api/servicesApi";

// Async thunk for fetching service
export const fetchAllServices = createAsyncThunk("service/fetchService", async (_, thunkAPI) => {
  try {
    const res = await servicesApi.getAll();

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const getServiceById = createAsyncThunk("service/serviceById", async (id, thunkAPI) => {
  try {
    const res = await servicesApi.getById(id);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const createService = createAsyncThunk("service/createService", async (serviceData, thunkAPI) => {
  try {
    const res = await servicesApi.create(serviceData);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteService = createAsyncThunk("service/deleteService", async (id, thunkAPI) => {
  try {
    const res = await servicesApi.delete(id);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateService = createAsyncThunk("service/updateService", async (serviceData, thunkAPI) => {
  try {
    const res = await servicesApi.update(serviceData.id, serviceData);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const serviceSlice = createSlice({
  name: "service",
  initialState: {
    services: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllServices.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload;
      })
      .addCase(fetchAllServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.loading = false;
        state.services = state.services.filter(service => service.id !== action.meta.arg);
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.loading = false;
        state.services = [...state.services, action.payload];
      })
      .addCase(createService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.services.findIndex(service => service.id === action.payload.id);
        if (index !== -1) {
          state.services[index] = action.payload;
        }
      })
      .addCase(updateService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    },
});

export default serviceSlice.reducer;
